(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["feelify-requirements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('feelify-requirements')) {
    customElements.define('feelify-requirements', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const opener = event.target.closest('[data-open-requirement]');
          if (opener && this.contains(opener)) {
            const dialog = document.getElementById(opener.dataset.openRequirement);
            if (dialog && !dialog.open) {
              this.invoker = opener;
              dialog.showModal();
            }
          }
          const closer = event.target.closest('[data-close-requirement]');
          if (closer) closer.closest('dialog').close();
        });
        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener('close', () => {
            if (this.invoker?.isConnected) this.invoker.focus({ preventScroll: true });
            this.invoker = null;
          });
          dialog.addEventListener('click', (event) => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
